<template>
  <div>
    <div ref="fotoPortadaRef" class="fotoportada-container">
      <!-- Oscurecimiento superior animado que baja de arriba hacia abajo -->
      <div ref="darkOverlayRef" class="dark-overlay-top"></div>

      <div class="overlay">
        <!-- MIS XV ESQUINA SUPERIOR IZQUIERDA -->
        <div class="mis-xv-wrapper-fixed">
          <div ref="misXvTopRef" class="mis-xv-top glowing"></div>
        </div>

        <!-- BLOQUE UNIFICADO DE TEXTO SUPERIOR -->
        <div ref="bloqueTextoRef" class="top-content-wrapper">
          <!-- NOMBRE EDITORIAL: A inicial caligráfica envolvente -->
          <div class="nombre-editorial">
            <span class="inicial-script">K</span><span class="resto-nombre">AROL ALONDRA</span>
            <div class="apellidos">  ROJAS IBARRA</div>
          </div>

          <!-- MIS XV -->
          <div class="mis-xv-main-text">
            MIS XV
          </div>

          <!-- FECHA DEL EVENTO -->
          <div class="fecha-evento">
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const misXvTopRef = ref(null)
    const bloqueTextoRef = ref(null)
    const darkOverlayRef = ref(null)

    onMounted(() => {
      ScrollTrigger.refresh()

      const tl = gsap.timeline({
        defaults: { ease: 'power3.out' }
      })

      // 1. Tag superior izquierdo
      tl.fromTo(
        misXvTopRef.value,
        { opacity: 0, y: -20, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 1.2 }
      )

      // 2. BLOQUE DE TEXTO COMPLETO: Emerge de pequeño a grande con blur suave
      .fromTo(
        bloqueTextoRef.value,
        {
          opacity: 0,
          scale: 0.78,
          y: -35,
          filter: 'blur(10px)'
        },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: 2.2,
          ease: 'power2.out'
        },
        '-=0.6'
      )

      // 3. OSCURECIMIENTO SUPERIOR: Baja progresivamente de arriba hacia abajo
      .fromTo(
        darkOverlayRef.value,
        { opacity: 0, scaleY: 0 },
        {
          opacity: 1,
          scaleY: 1,
          duration: 2.0,
          ease: 'sine.inOut'
        },
        '-=1.4'
      )
    })

    return {
      fotoPortadaRef,
      misXvTopRef,
      bloqueTextoRef,
      darkOverlayRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Pinyon+Script&display=swap');

body {
  margin: 0;
  padding: 0;
}

/* ================= CONTENEDOR FOTO ================= */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -65px;
  background-image: url('@/assets/1_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
}

/* ================= CAPA DE OSCURECIMIENTO (DE ARRIBA HACIA ABAJO) ================= */
.dark-overlay-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.88) 0%,
    rgba(0, 0, 0, 0.5) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
  z-index: 2;
  transform-origin: top center; /* La animación baja estrictamente desde arriba */
  will-change: opacity, transform;
}

/* ================= OVERLAY Y CONTENIDOS ================= */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Todo alineado arriba */
  align-items: center;
  color: white;
  z-index: 3;
  box-sizing: border-box;
}

/* ================= MIS XV SUPERIOR IZQUIERDA ================= */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: 30px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 4;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 18px;
  letter-spacing: 1px;
  color: white;
}

.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from { text-shadow: 0 0 6px rgba(255, 255, 255, 0.3); }
  to   { text-shadow: 0 0 16px rgba(255, 255, 255, 0.9); }
}

/* ================= BLOQUE DE TEXTO SUPERIOR ================= */
.top-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  padding: 0 20px;
  text-align: center;
  will-change: transform, opacity, filter;
  transform-origin: center center;
}

/* ESTIMACIÓN EXACTA DEL ESTILO DEL NOMBRE */
.nombre-editorial {
  position: relative;
  line-height: 0.8;
  margin-bottom: 15px;
  color: #ffffff;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.inicial-script {
  font-family: 'Pinyon Script', 'Great Vibes', cursive;
  font-size: 105px;
  font-weight: 400;
  display: inline-block;
  transform: translateY(18px) translateX(10px); /* Ajuste para envolver la siguiente letra */
  margin-right: 20px;
}

.resto-nombre {
  font-family: 'Cormorant Garamond', 'Cinzel', serif;
  font-size: 48px;
  font-weight: 300;
  letter-spacing: 6px;
}

.apellidos {
  font-family: 'Cinzel', serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 10px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 10px;
  text-align: center;
}

/* ESTILO MIS XV INFERIOR */
.mis-xv-main-text {
  font-family: 'Cinzel', serif;
  font-size: 38px;
  font-weight: 400;
  letter-spacing: 8px;
  color: #ffffff;
  margin-top: 15px;
  text-transform: uppercase;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.6);
}

/* FECHA DEL EVENTO */
.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  letter-spacing: 5px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
}
</style>